<div class="col-12">
	<div class="errorMessage" *ngIf="!(supportedBrowser | async)">
		For a better user experience we would recommend using Google Chrome, Safari
		or Firefox.
	</div>
	<div class="dib notranslate">{{ footerLabel }}</div>
	<div *ngIf="!production()" class="dib notranslate">{{ clusterId }}</div>
</div>
